module.exports = require( './lib/qap' ).Qap;

